/**
 *  Radio script file
**/

export default {
  name: 'Radio',
  mixins: [],
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Boolean, Number],
      default: ''
    },
    value: {
      type: [String, Boolean, Number],
      default: ''
    },
    rvalue: {
      type: [String, Boolean, Number],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    radioButtonValue: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('change', value)
        this.$parent.$emit('change', value)
      }
    },
    getClasses () {
      return {
        'disabled': this.disabled
      }
    },
    getRadioClasses () {
      return {
        'disabled': this.disabled
      }
    }
  },
  methods: {}
}
